import React from 'react'

export const EyeIcon = (props: React.SVGProps<SVGSVGElement>) => {
  const [maskId] = React.useState(() => `path-1-inside-1_${Date.now()}`)
  return (
    <svg
      width='24'
      height='24'
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...props}
    >
      <mask id={maskId} fill='white'>
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M4.58203 12C5.76881 9.06817 8.64314 7 12.0005 7C15.3579 7 18.2322 9.06817 19.419 12C18.2322 14.9318 15.3579 17 12.0005 17C8.64314 17 5.76881 14.9318 4.58203 12Z'
        />
      </mask>
      <path
        mask={`url(#${maskId})`}
        d='M4.58203 12L3.65509 11.6248L3.50321 12L3.65509 12.3752L4.58203 12ZM19.419 12L20.3459 12.3752L20.4978 12L20.3459 11.6248L19.419 12ZM4.58203 12L5.50897 12.3752C6.54814 9.80802 9.06438 8 12.0005 8V7V6C8.22189 6 4.98947 8.32832 3.65509 11.6248L4.58203 12ZM12.0005 7V8C14.9366 8 17.4529 9.80802 18.4921 12.3752L19.419 12L20.3459 11.6248C19.0116 8.32832 15.7791 6 12.0005 6V7ZM19.419 12L18.4921 11.6248C17.4529 14.192 14.9366 16 12.0005 16V17V18C15.7791 18 19.0116 15.6717 20.3459 12.3752L19.419 12ZM12.0005 17V16C9.06438 16 6.54814 14.192 5.50897 11.6248L4.58203 12L3.65509 12.3752C4.98947 15.6717 8.22189 18 12.0005 18V17Z'
        fill='currentColor'
      />
      <circle cx='12' cy='12' r='2.5' stroke='#827C8C' />
    </svg>
  )
}
